<div class="bookings-tile">
  <div class="container">
    <div class="row">
      <div class="col-12">
        <span
          class="status lato bold"
          [ngClass]="{
            'waitlist': booking.status === 0,
            'confirmed':  booking.status === 1,
            'checkedIn': booking.status === 2,
            'pending':  booking.status === 9,
            'declined':  booking.status === 10
          }"
        >
          {{ booking.statusTypeTextUI }}
        </span>
      </div>
    </div>
    <div class="row">
      <div class="col-12 status-message">
        <div class="status-message">{{ booking.statusMessageUI }}</div>
      </div>
    </div>
    <hr class="divider">
    <div class="row">
      <div class="col-12">
        <h5 class="lato bold">{{ booking.bookingTitleUI}}</h5>
      </div>
    </div>
    <div class="row">
      <div class="col-12 lato bold">
        {{ booking.petNamesUI }}
      </div>
    </div>
    <div class="row">
      <div class="col-12 lato">
        {{ booking.franchise.name }}
      </div>
    </div>
    <div class="row btn-row-container">
      <div
        *ngIf="booking.status !== 10"
        class="col btn-container cancel-btn"
      >
        <button
          class="btn btn-outline-danger btn-block"
          (click)="viewBookingDetails()"
        >View</button>
      </div>
      <div
        *ngIf="booking.status !== 10"
        class="col btn-container view-btn"
      >
        <button
          class="btn btn-outline-danger btn-block"
          (click)="cancelBooking()"
        >Change/Cancel</button>
      </div>
      <div
        *ngIf="booking.status === 10"
        class="col-12 btn-container"
      >
        <button
          class="btn btn-block btn-outline-danger"
          (click)="viewBookingDetails()"
        >View</button>
      </div>
    </div>
  </div>
</div>
